module.exports = __webpack_public_path__ + "img/flyer.d25bffde.svg";